import { useColorFromEnum } from '@features/appointment-types';

import type { CalendarEvent } from '../../../types';
import type { ColorTreatment } from '../types';
import { lightenColor } from '../utils/colorUtils';

/**
 * React hook to determine color treatment based on appointment state
 * Uses backend-provided appointment.color field to map to theme colors,
 * then applies completion modifier for visual state
 *
 * @param event - Calendar event with appointment data
 * @returns Color treatment with background, text, and accent colors
 */
export const useEventColorTreatment = (event: CalendarEvent): ColorTreatment => {
  const resource = event.resource;

  // Get base color from backend appointment.color field (color1, color2, etc.)
  let baseColor = useColorFromEnum(resource.color);

  // Check if encounter is completed
  const isCompleted = (resource.encounter as { status?: string } | null)?.status === 'completed';
  if (isCompleted) {
    baseColor = lightenColor(baseColor);
  }

  return {
    backgroundColor: baseColor,
    textColor: '#ffffff',
    accentColor: baseColor,
  };
};
